document.addEventListener("DOMContentLoaded", function () {
  var toggleBtn = document.getElementById("toggleDescription");
  var descFull = document.querySelector(".category-description__full");
  var showText = document.querySelector(".category-description__show");
  var hideText = document.querySelector(".category-description__hide");
  if (toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      descFull.classList.toggle("is-expanded");
      if (descFull.classList.contains("is-expanded")) {
        showText.style.display = "none";
        hideText.style.display = "inline";
      } else {
        showText.style.display = "inline";
        hideText.style.display = "none";
      }
    });
  }
});
